import Icon from '../Icon/Icon';
import { usePageContext } from 'context/hooks/usePageContext';
import { PAGES } from 'context/pageContext';
import React, { FC } from 'react';

interface PaymentSelectorProps extends React.HTMLAttributes<HTMLButtonElement> {
  name: PAGES;
  icon: any;
  handlePageChange?: (name: PAGES) => void;
  disabled?: boolean;
  isOpay?: boolean;
}

const PaymentSelector: FC<PaymentSelectorProps> = ({
  name,
  icon,
  handlePageChange,
  onClick,
  disabled,
  isOpay,
}) => {
  const { page } = usePageContext();

  return (
    <button
      className={`flex items-center gap-2 pl-4 p-4 cursor-pointer rounded-lg 
        font-600 w-full ${
          page === name
            ? 'bg-[#C9E5FF] text-[#0284F8]'
            : 'text-[#121212] hover:bg-[#0284F8]/40 hover:text-white'
        } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 disabled:pointer-events-none`}
      onClick={(e) => {
        handlePageChange?.(name);
        onClick?.(e);
      }}
      disabled={disabled}
    >
      <Icon
        svg={icon}
        className="fill-current"
        width={isOpay ? 54 : 16}
        height={isOpay ? 20 : 16}
      />
      Pay with {name}
    </button>
  );
};

export default PaymentSelector;
